import {RootState} from '@/store'
import {AuthenticationState} from '@/store/modules/authentication'
import {UserDetailsResponse} from '@payroll/optimus-common'
import {GetterTree} from 'vuex'

export const getters: GetterTree<AuthenticationState, RootState> = {

  obfuscatedPhoneNum(state): string {
    return state.obfuscatedPhoneNum
  },

  obfuscatedEmail(state): string {
    return state.obfuscatedEmail
  },

  userDetails(state): UserDetailsResponse {
    return state.userDetails
  },

  mngCompanyName(state): string {
    return state.mngCompanyName
  },

  authorizedPages(state): string[] {
    return state.authorizedPages
  },

  customerDetails(state): any {
    return state.customerDetails
  },

  idNumber(state): string {
    return state.idNumber
  },

  clientErrorIndication(state): boolean {
    return state.clientErrorIndication
  },


  oprEntityKey(state): number {
    return state.oprEntityKey
  },

};